import React, { Component, Fragment } from "react";
import Slider from "react-slick";

export default class MultipleItems extends Component {

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <div className="news-outer">
        <Slider {...settings}>
          {this.props.values.map((value, index) => (
            <Fragment key={'news-outer'+index}>
              {
                <div className="news-wrap">
                  <a href={value.url} key={`figures${index}`} >
                    <div className="news-image" dangerouslySetInnerHTML={{ __html: value.image }}></div>
                    {value.text && 
                      <h3 className="slider__text">
                          {value.text}
                      </h3>
                    }
                    {value.desc != '' && (<p >{`${value.desc.substring(0, 100)}...`} </p>)}
                  </a>
                </div>
              }
            </Fragment>
          ))}
        </Slider>
      </div>
    );
  }
}
